import { IHttpError } from '@app/core/interfaces/error.interface';
import { IPvsTaskInfo } from '@app/core/interfaces/pvs-task.interface';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PvsTaskActions = createActionGroup({
  source: 'PVS_TASK',
  events: {
    requestTaskInfo: emptyProps(),
    requestTaskInfoSuccess: props<{ task: IPvsTaskInfo }>(),
    requestTaskInfoError: props<{
      error: IHttpError;
    }>(),
    requestSetTaskAccept: props<{
      id: number;
    }>(),
    requestSetTaskAcceptSuccess: emptyProps(),
    requestSetTaskAcceptError: props<{
      error: IHttpError;
    }>(),
    requestSetTaskOnWay: props<{
      id: number;
    }>(),
    requestSetTaskOnWaySuccess: emptyProps(),
    requestSetTaskOnWayError: props<{
      error: IHttpError;
    }>(),
    requestSetTaskAtObject: props<{
      id: number;
    }>(),
    requestSetTaskAtObjectSuccess: emptyProps(),
    requestSetTaskAtObjectError: props<{
      error: IHttpError;
    }>(),
    requestSetTaskInProgress: props<{
      id: number;
    }>(),
    requestSetTaskInProgressSuccess: emptyProps(),
    requestSetTaskInProgressError: props<{
      error: IHttpError;
    }>(),
    requestSetTaskComplete: props<{
      id: number;
    }>(),
    requestSetTaskCompleteSuccess: emptyProps(),
    requestSetTaskCompleteError: props<{
      error: IHttpError;
    }>(),
    requestSetTaskCancel: props<{
      id: number;
    }>(),
    requestSetTaskCancelSuccess: emptyProps(),
    requestSetTaskCancelError: props<{
      error: IHttpError;
    }>(),
  },
});
